// extracted by mini-css-extract-plugin
export var header = "styles-module--header--149pG";
export var left_sidebar_container = "styles-module--left_sidebar_container--2Cf6F";
export var left_sidebar = "styles-module--left_sidebar--2IOzL";
export var progress_bar = "styles-module--progress_bar--1t2CU";
export var progress_bar_inner = "styles-module--progress_bar_inner--2hNII";
export var right_sidebar = "styles-module--right_sidebar--ZcUSF";
export var nav = "styles-module--nav--3gzC6";
export var logo = "styles-module--logo--1ZRCz";
export var main = "styles-module--main--1Zpld";
export var inner_section = "styles-module--inner_section--3lPMw";
export var me = "styles-module--me--1a7RO";
export var project_section = "styles-module--project_section--2n-si";
export var project = "styles-module--project--1ANYD";
export var project_content = "styles-module--project_content--C4DMC";